import { AuctionBidHistoryDTO } from "../DTO/auctionBidHistoryDTO";
import { AuctionBidAdmin } from "./auctionBidAdmin";

export class AuctionBidHistory{
    public auctionId!:number;
    public scheduleSeqNo!:number;
    public void:boolean = false;
    public voidIndex?:number;
    public auctionBids!:AuctionBidAdmin[];

    public static mapToDTO(param:AuctionBidHistory) : AuctionBidHistoryDTO{
        
        let dto = new AuctionBidHistoryDTO();
        try
        {
            dto.auctionId = param.auctionId;
            dto.scheduleSeqNo = param.scheduleSeqNo;
            dto.void = param.void;
            dto.voidIndex = param.voidIndex;
            dto.auctionBids = param.auctionBids.map(ab => AuctionBidAdmin.mapToDTO(ab));
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:AuctionBidHistoryDTO) : AuctionBidHistory
    {
        
        let obj = new AuctionBidHistory();
        try
        {
            obj.auctionId = param.auctionId;
            obj.scheduleSeqNo = param.scheduleSeqNo;
            obj.void = param.void;
            obj.voidIndex = param.voidIndex;
            obj.auctionBids = param.auctionBids.map(ab => AuctionBidAdmin.mapFromDTO(ab));
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    get voidInfo(){
        if(this.void && this.voidIndex) return ` (Void${this.voidIndex>0? ` #${this.voidIndex}` : ''})`;
        else return '';
    }
}